import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import Spinner from "web/components/Spinner";
import TextInput from "web/components/form-elements/TextInput";
import PhoneNumber from 'web/components/form-elements/PhoneNumber';
import { adminAddLocationUserApi } from 'redux/actions/adminPtPlus/index';
import { InputFieldsWrapper } from '.././PTPlusStyled'
import AlertModal from 'web/components/AlertModal';
import CloseIcon from "web/assets/images/CloseIcon.png";

function AddUserModal(pageProps) {
    const dispatch = useDispatch();
    let history = useHistory()
    const loaderVisible = useSelector(state => state.appReducer.loaderVisible);
    const [alertModal, setAlertModal] = useState(false);
    const [alertModalContent, setAlertModalContent] = useState('');
    const [alertType, setAlertType] = useState('')
    const [saveDisableState, setSaveDisableState] = useState(true)
    let pageFieldValues = pageProps.formikProps.values

    useEffect(() => {
        pageProps.setFieldValue('addUserName', '')
        pageProps.setFieldValue('addUserEmail', '')
        pageProps.setFieldValue('addUserPhoneNumber', '')
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        let fieldValues = pageProps.formikProps.values
        if (fieldValues.addUserName !== '' && fieldValues.addUserEmail !== '' && fieldValues.addUserPhoneNumber !== '') setSaveDisableState(false)
        else setSaveDisableState(true)
    }, [pageProps.formikProps])

    const addLocationUserFunction = async () => {
        let fieldValues = pageProps.formikProps.values
        let response = ''
        let id = pageProps.clickedLocationDetails.locationId
        let data = {
            emailAddress: fieldValues.addUserEmail,
            contactNumber: fieldValues.addUserPhoneNumber,
            customerName: fieldValues.addUserName,
            locationName: fieldValues.addUserName,
            roles: 'roles'
        }
        const token = localStorage.getItem('token')
        response = await dispatch(adminAddLocationUserApi(id, data, token))

        if (response.success) {
            setAlertModalContent(response?.data?.msg)
            setAlertType('adminSubUserLocation')
            setAlertModal(!alertModal)
        } else {
            if (response?.statusCode === 401) {
                history.push('/sign-in')
                window.location.reload(false);
            } else {
                setAlertModalContent(response?.data?.error?.message || 'Something went wrong, plese try again.')
                setAlertModal(!alertModal)
            }
        }
    }

    return (
        <>
            {loaderVisible && <Spinner />}
            <div>
                <div className="modal-header-style">
                    <h6>Add User</h6>
                    <img src={CloseIcon} alt="close-icon" onClick={() => pageProps.toggle()} />
                </div>


                <div style={{ padding: '25px' }}>
                    <InputFieldsWrapper>
                        <div className="row">
                            <div className="col-md-6 fixed-height">
                                {pageFieldValues.addUserName !== '' && <h6>Full Name<span className='star'>&#42;</span></h6>}
                                <div className='height-adjust'><TextInput name='addUserName' placeholder={`Full Name*`} inputType='text' /></div>
                            </div>
                            <div className='col-md-6 fixed-height'>
                                {pageFieldValues.addUserEmail !== '' && <h6>Email<span className='star'>&#42;</span></h6>}
                                <div className='height-adjust'><TextInput name="addUserEmail" placeholder={`Email*`} />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-6 fixed-height">
                                {pageFieldValues.addUserPhoneNumber !== '' && <h6>Cell Phone Number<span className='star'>&#42;</span></h6>}
                                <div className='height-adjust'><PhoneNumber name="addUserPhoneNumber" placeholder={`Cell Phone Number*`} /></div>
                            </div>
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                            <button className='green-button' style={{ opacity: saveDisableState ? 0.5 : 1 }} disabled={saveDisableState} onClick={addLocationUserFunction}>Add User</button>
                        </div>
                    </InputFieldsWrapper>
                </div>
            </div>
            <AlertModal
                isOpen={alertModal}
                toggle={() => setAlertModal(!alertModal)}
                content={alertModalContent}
                alertType={alertType}
                callBackAlert={() => {
                    if(alertType === 'adminSubUserLocation'){
                        pageProps.fetchLocationsListFunction()
                        pageProps.toggle()
                    }
                }}
            />
        </>
    );
}

export default AddUserModal;
